unit Search.SystemTypes;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, VCL.TMSFNCTypes, VCL.TMSFNCUtils,
  VCL.TMSFNCGraphics, VCL.TMSFNCGraphicsTypes, VCL.TMSFNCGridCell,
  VCL.TMSFNCGridOptions, Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls,
  WEBLib.Buttons, VCL.TMSFNCCustomComponent, VCL.TMSFNCCustomGrid,
  VCL.TMSFNCGridDatabaseAdapter, VCL.TMSFNCCustomControl,
  VCL.TMSFNCCustomScrollControl, VCL.TMSFNCGridData, VCL.TMSFNCGrid,
  WEBLib.ExtCtrls, Data.DB, XData.Web.JsonDataset, XData.Web.Dataset, WEBLib.DB,
  XData.Web.Client;

type
  TfrmSystemTypesSearch = class(TForm)
    wsbMain: TScrollBox;
    wpMain: TPanel;
    gSearch: TTMSFNCGrid;
    gdaSearch: TTMSFNCGridDatabaseAdapter;
    WebPanel1: TPanel;
    btnBack: TSpeedButton;
    btnSelect: TSpeedButton;
    weSearch: TEdit;
    WebLabel1: TLabel;
    wcSystemTypes: TXDataWebClient;
    dsSystemtypes: TDataSource;
    wdsSystemTypes: TXDataWebDataSet;
    wdsSystemTypesSystemNO: TIntegerField;
    wdsSystemTypesDescription: TStringField;
    procedure WebFormShow(Sender: TObject);
    procedure btnSelectClick(Sender: TObject);
    procedure weSearchChange(Sender: TObject);
    procedure btnBackClick(Sender: TObject);
  private
    { Private declarations }
  public
    { Public declarations }
    iSystemNo : Integer;
    sDescription : String;
  protected procedure LoadDFMValues; override; end;

var
  frmSystemTypesSearch: TfrmSystemTypesSearch;

implementation

{$R *.dfm}
uses
  stfmssystem.connection, share.common;

procedure TfrmSystemTypesSearch.btnBackClick(Sender: TObject);
begin
  Close;
end;

procedure TfrmSystemTypesSearch.btnSelectClick(Sender: TObject);
begin
  iSystemNo := wdsSystemTypes.FieldByName('SystemNO').AsInteger;
  sDescription := wdsSystemTypes.FieldByName('Description').AsString;
  Close;
end;

procedure TfrmSystemTypesSearch.WebFormShow(Sender: TObject);
  procedure OnResutSystemType(Response : TXDataClientResponse);
    begin
      wdsSystemtypes.Close;
      wdsSystemtypes.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
      wdsSystemtypes.Open;

      console.log(GetJsonFromDataSet(wdsSystemtypes));

    end;

begin
  wcSystemTypes.RawInvoke('IstfmsSystemService.Get_SystemTypes',['*'],@OnResutSystemType);
end;

procedure TfrmSystemTypesSearch.weSearchChange(Sender: TObject);
begin
  if weSearch.Text <> '' then
    begin
      case gSearch.Selection.StartCol of
        0 : wdsSystemTypes.Locate('SystemNO', weSearch.Text, [loPartialKey]);
        1 : wdsSystemTypes.Locate('Description', weSearch.Text, [loPartialKey]);

      end;
    end;
end;

procedure TfrmSystemTypesSearch.LoadDFMValues;
begin
  inherited LoadDFMValues;

  wsbMain := TScrollBox.Create(Self);
  wpMain := TPanel.Create(Self);
  WebLabel1 := TLabel.Create(Self);
  gSearch := TTMSFNCGrid.Create(Self);
  gdaSearch := TTMSFNCGridDatabaseAdapter.Create(Self);
  WebPanel1 := TPanel.Create(Self);
  btnBack := TSpeedButton.Create(Self);
  btnSelect := TSpeedButton.Create(Self);
  weSearch := TEdit.Create(Self);
  wcSystemTypes := TXDataWebClient.Create(Self);
  dsSystemtypes := TDataSource.Create(Self);
  wdsSystemTypes := TXDataWebDataSet.Create(Self);
  wdsSystemTypesSystemNO := TIntegerField.Create(Self);
  wdsSystemTypesDescription := TStringField.Create(Self);

  wsbMain.BeforeLoadDFMValues;
  wpMain.BeforeLoadDFMValues;
  WebLabel1.BeforeLoadDFMValues;
  gSearch.BeforeLoadDFMValues;
  gdaSearch.BeforeLoadDFMValues;
  WebPanel1.BeforeLoadDFMValues;
  btnBack.BeforeLoadDFMValues;
  btnSelect.BeforeLoadDFMValues;
  weSearch.BeforeLoadDFMValues;
  wcSystemTypes.BeforeLoadDFMValues;
  dsSystemtypes.BeforeLoadDFMValues;
  wdsSystemTypes.BeforeLoadDFMValues;
  wdsSystemTypesSystemNO.BeforeLoadDFMValues;
  wdsSystemTypesDescription.BeforeLoadDFMValues;
  try
    Name := 'frmSystemTypesSearch';
    Width := 465;
    Height := 325;
    SetEvent(Self, 'OnShow', 'WebFormShow');
    wsbMain.SetParentComponent(Self);
    wsbMain.Name := 'wsbMain';
    wsbMain.Left := 0;
    wsbMain.Top := 0;
    wsbMain.Width := 465;
    wsbMain.Height := 325;
    wsbMain.Align := alClient;
    wsbMain.AutoScroll := True;
    wsbMain.BorderStyle := bsSingle;
    wpMain.SetParentComponent(wsbMain);
    wpMain.Name := 'wpMain';
    wpMain.Left := 0;
    wpMain.Top := 0;
    wpMain.Width := 465;
    wpMain.Height := 325;
    wpMain.Align := alClient;
    wpMain.Color := clSilver;
    wpMain.TabOrder := 0;
    WebLabel1.SetParentComponent(wpMain);
    WebLabel1.Name := 'WebLabel1';
    WebLabel1.Left := 0;
    WebLabel1.Top := 0;
    WebLabel1.Width := 465;
    WebLabel1.Height := 32;
    WebLabel1.Align := alTop;
    WebLabel1.Alignment := taCenter;
    WebLabel1.AutoSize := False;
    WebLabel1.Caption := 'Search System Types';
    WebLabel1.ElementFont := efCSS;
    WebLabel1.HeightStyle := ssAuto;
    WebLabel1.HeightPercent := 100.000000000000000000;
    WebLabel1.Layout := tlCenter;
    WebLabel1.WidthPercent := 100.000000000000000000;
    gSearch.SetParentComponent(wpMain);
    gSearch.Name := 'gSearch';
    gSearch.Left := 0;
    gSearch.Top := 32;
    gSearch.Width := 465;
    gSearch.Height := 211;
    gSearch.Align := alClient;
    gSearch.ParentDoubleBuffered := False;
    gSearch.DoubleBuffered := True;
    gSearch.Font.Charset := DEFAULT_CHARSET;
    gSearch.Font.Color := clWindowText;
    gSearch.Font.Height := -13;
    gSearch.Font.Name := 'Tahoma';
    gSearch.Font.Style := [];
    gSearch.ParentFont := False;
    gSearch.TabOrder := 0;
    gSearch.DefaultRowHeight := 28.000000000000000000;
    gSearch.FixedColumns := 0;
    gSearch.RowCount := 1;
    gSearch.Options.Bands.Enabled := True;
    gSearch.Options.Editing.CalcFormat := '%g';
    gSearch.Options.Editing.Enabled := False;
    gSearch.Options.Grouping.CalcFormat := '%g';
    gSearch.Options.Grouping.GroupCountFormat := '(%d)';
    gSearch.Options.IO.XMLEncoding := 'ISO-8859-1';
    gSearch.Options.Mouse.ClickMargin := 0;
    gSearch.Options.Mouse.ColumnSizeMargin := 6;
    gSearch.Options.Mouse.RowSizeMargin := 6;
    gSearch.Options.Sorting.MultiColumn := False;
    gSearch.Adapter := gdaSearch;
    gSearch.Columns.Clear;
    with gSearch.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := clWindowText;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := clWindowText;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      Name := 'SystemNO';
      Width := 150.000000000000000000;
    end;
    with gSearch.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := clWindowText;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := clWindowText;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      Name := 'Description';
      Width := 250.000000000000000000;
    end;
    gSearch.DefaultFont.Charset := DEFAULT_CHARSET;
    gSearch.DefaultFont.Color := clWindowText;
    gSearch.DefaultFont.Height := -11;
    gSearch.DefaultFont.Name := 'Segoe UI';
    gSearch.DefaultFont.Style := [];
    gSearch.TopRow := 1;
    gSearch.Appearance.FixedLayout.Fill.Color := 16380654;
    gSearch.Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
    gSearch.Appearance.FixedLayout.Font.Color := 4539717;
    gSearch.Appearance.FixedLayout.Font.Height := -13;
    gSearch.Appearance.FixedLayout.Font.Name := 'Segoe UI';
    gSearch.Appearance.FixedLayout.Font.Style := [fsBold];
    gSearch.Appearance.NormalLayout.Fill.Color := 16578806;
    gSearch.Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
    gSearch.Appearance.NormalLayout.Font.Color := 8026746;
    gSearch.Appearance.NormalLayout.Font.Height := -11;
    gSearch.Appearance.NormalLayout.Font.Name := 'Segoe UI';
    gSearch.Appearance.NormalLayout.Font.Style := [];
    gSearch.Appearance.GroupLayout.Fill.Color := 12817262;
    gSearch.Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
    gSearch.Appearance.GroupLayout.Font.Color := clBlack;
    gSearch.Appearance.GroupLayout.Font.Height := -11;
    gSearch.Appearance.GroupLayout.Font.Name := 'Segoe UI';
    gSearch.Appearance.GroupLayout.Font.Style := [];
    gSearch.Appearance.SummaryLayout.Fill.Color := 14009785;
    gSearch.Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
    gSearch.Appearance.SummaryLayout.Font.Color := clBlack;
    gSearch.Appearance.SummaryLayout.Font.Height := -11;
    gSearch.Appearance.SummaryLayout.Font.Name := 'Segoe UI';
    gSearch.Appearance.SummaryLayout.Font.Style := [];
    gSearch.Appearance.SelectedLayout.Fill.Color := 16441019;
    gSearch.Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
    gSearch.Appearance.SelectedLayout.Font.Color := 4539717;
    gSearch.Appearance.SelectedLayout.Font.Height := -11;
    gSearch.Appearance.SelectedLayout.Font.Name := 'Segoe UI';
    gSearch.Appearance.SelectedLayout.Font.Style := [];
    gSearch.Appearance.FocusedLayout.Fill.Color := 16039284;
    gSearch.Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
    gSearch.Appearance.FocusedLayout.Font.Color := 4539717;
    gSearch.Appearance.FocusedLayout.Font.Height := -11;
    gSearch.Appearance.FocusedLayout.Font.Name := 'Segoe UI';
    gSearch.Appearance.FocusedLayout.Font.Style := [];
    gSearch.Appearance.FixedSelectedLayout.Fill.Color := clLightsteelblue;
    gSearch.Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
    gSearch.Appearance.FixedSelectedLayout.Font.Color := clBlack;
    gSearch.Appearance.FixedSelectedLayout.Font.Height := -11;
    gSearch.Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
    gSearch.Appearance.FixedSelectedLayout.Font.Style := [];
    gSearch.Appearance.BandLayout.Fill.Color := 16711679;
    gSearch.Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
    gSearch.Appearance.BandLayout.Font.Color := 8026746;
    gSearch.Appearance.BandLayout.Font.Height := -11;
    gSearch.Appearance.BandLayout.Font.Name := 'Segoe UI';
    gSearch.Appearance.BandLayout.Font.Style := [];
    gSearch.Appearance.ProgressLayout.Format := '%.0f%%';
    gSearch.LeftCol := 0;
    gSearch.ScrollMode := scmItemScrolling;
    gSearch.DesignTimeSampleData := True;
    gdaSearch.SetParentComponent(gSearch);
    gdaSearch.Name := 'gdaSearch';
    gdaSearch.Left := 176;
    gdaSearch.Top := 72;
    gdaSearch.Width := 26;
    gdaSearch.Height := 26;
    gdaSearch.Visible := True;
    gdaSearch.Active := True;
    gdaSearch.Grid := gSearch;
    gdaSearch.DataSource := dsSystemtypes;
    gdaSearch.Columns.Clear;
    with gdaSearch.Columns.Add do
    begin
      FieldName := 'SystemNO';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    with gdaSearch.Columns.Add do
    begin
      FieldName := 'Description';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    gdaSearch.AutoCreateColumns := False;
    WebPanel1.SetParentComponent(wpMain);
    WebPanel1.Name := 'WebPanel1';
    WebPanel1.Left := 0;
    WebPanel1.Top := 243;
    WebPanel1.Width := 465;
    WebPanel1.Height := 82;
    WebPanel1.Align := alBottom;
    WebPanel1.ChildOrder := 2;
    WebPanel1.Color := clSilver;
    WebPanel1.TabOrder := 1;
    btnBack.SetParentComponent(WebPanel1);
    btnBack.Name := 'btnBack';
    btnBack.Left := 330;
    btnBack.Top := 34;
    btnBack.Width := 108;
    btnBack.Height := 35;
    btnBack.Caption := 'Close';
    btnBack.Color := clCrimson;
    btnBack.Font.Charset := DEFAULT_CHARSET;
    btnBack.Font.Color := clWhite;
    btnBack.Font.Height := -13;
    btnBack.Font.Name := 'Tahoma';
    btnBack.Font.Style := [fsBold];
    btnBack.HeightStyle := ssAuto;
    btnBack.HeightPercent := 100.000000000000000000;
    btnBack.ParentFont := False;
    btnBack.TabOrder := 0;
    btnBack.WidthPercent := 100.000000000000000000;
    SetEvent(btnBack, Self, 'OnClick', 'btnBackClick');
    btnSelect.SetParentComponent(WebPanel1);
    btnSelect.Name := 'btnSelect';
    btnSelect.Left := 18;
    btnSelect.Top := 38;
    btnSelect.Width := 108;
    btnSelect.Height := 35;
    btnSelect.Caption := 'Select';
    btnSelect.Color := clGreenyellow;
    btnSelect.Font.Charset := DEFAULT_CHARSET;
    btnSelect.Font.Color := clBlack;
    btnSelect.Font.Height := -13;
    btnSelect.Font.Name := 'Tahoma';
    btnSelect.Font.Style := [fsBold];
    btnSelect.HeightStyle := ssAuto;
    btnSelect.HeightPercent := 100.000000000000000000;
    btnSelect.ParentFont := False;
    btnSelect.TabOrder := 1;
    btnSelect.WidthPercent := 100.000000000000000000;
    SetEvent(btnSelect, Self, 'OnClick', 'btnSelectClick');
    weSearch.SetParentComponent(WebPanel1);
    weSearch.Name := 'weSearch';
    weSearch.Left := 18;
    weSearch.Top := 6;
    weSearch.Width := 420;
    weSearch.Height := 22;
    weSearch.CharCase := wecUpperCase;
    weSearch.ChildOrder := 2;
    weSearch.Font.Charset := DEFAULT_CHARSET;
    weSearch.Font.Color := clWindowText;
    weSearch.Font.Height := -13;
    weSearch.Font.Name := 'Tahoma';
    weSearch.Font.Style := [];
    weSearch.HeightStyle := ssAuto;
    weSearch.HeightPercent := 100.000000000000000000;
    weSearch.ParentFont := False;
    weSearch.WidthPercent := 100.000000000000000000;
    SetEvent(weSearch, Self, 'OnChange', 'weSearchChange');
    wcSystemTypes.SetParentComponent(Self);
    wcSystemTypes.Name := 'wcSystemTypes';
    wcSystemTypes.Connection := dmData.dbConnect;
    wcSystemTypes.Left := 32;
    wcSystemTypes.Top := 104;
    dsSystemtypes.SetParentComponent(Self);
    dsSystemtypes.Name := 'dsSystemtypes';
    dsSystemtypes.AutoEdit := False;
    dsSystemtypes.DataSet := wdsSystemTypes;
    dsSystemtypes.Left := 128;
    dsSystemtypes.Top := 104;
    wdsSystemTypes.SetParentComponent(Self);
    wdsSystemTypes.Name := 'wdsSystemTypes';
    wdsSystemTypes.Connection := dmData.dbConnect;
    wdsSystemTypes.Left := 80;
    wdsSystemTypes.Top := 104;
    wdsSystemTypesSystemNO.SetParentComponent(wdsSystemTypes);
    wdsSystemTypesSystemNO.Name := 'wdsSystemTypesSystemNO';
    wdsSystemTypesSystemNO.FieldName := 'SystemNO';
    wdsSystemTypesDescription.SetParentComponent(wdsSystemTypes);
    wdsSystemTypesDescription.Name := 'wdsSystemTypesDescription';
    wdsSystemTypesDescription.FieldName := 'Description';
  finally
    wsbMain.AfterLoadDFMValues;
    wpMain.AfterLoadDFMValues;
    WebLabel1.AfterLoadDFMValues;
    gSearch.AfterLoadDFMValues;
    gdaSearch.AfterLoadDFMValues;
    WebPanel1.AfterLoadDFMValues;
    btnBack.AfterLoadDFMValues;
    btnSelect.AfterLoadDFMValues;
    weSearch.AfterLoadDFMValues;
    wcSystemTypes.AfterLoadDFMValues;
    dsSystemtypes.AfterLoadDFMValues;
    wdsSystemTypes.AfterLoadDFMValues;
    wdsSystemTypesSystemNO.AfterLoadDFMValues;
    wdsSystemTypesDescription.AfterLoadDFMValues;
  end;
end;

end.